import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/event_sample2.png")